import { createContext, useContext } from 'react';
import type { LngLatBase } from '@/views/map/types';
import type { BoundingBoxString } from '@/features/types';

export interface MapHoveredItem {
  source: 'map';
  coordinate: LngLatBase;
  groupName: string;
}

export interface ListHoveredItem {
  source: 'list';
  bbox?: BoundingBoxString;
  groupName?: string;
}

export type HoveredItem = MapHoveredItem | ListHoveredItem;

interface HoverContextType {
  hoveredItem: HoveredItem | null;
  setHoveredItem: (item: HoveredItem | null) => void;
  hoverLocation: LngLatBase | null;
}

export const HoverContext = createContext<HoverContextType | null>(null);

export const useHover = (): HoverContextType => {
  const context = useContext(HoverContext);
  if (!context) {
    throw new Error('useHover must be used within a HoverProvider');
  }
  return context;
};
